import React, { Fragment } from "react";
import flatten from "lodash/flatten";
import chunk from "lodash/chunk";
import { Link } from "@quintype/components";
import { ImageThumbnail } from "../../atoms/ImageThumbnail";
import { replaceWithAlternates } from "../../../utils";
import "./also-in-this-package.m.css";

export const AlsoInPackage = ({ storyCollection }) => {
  return (
    <div styleName="wrapper">
      {flatten(
        chunk(storyCollection, 2).map((storyGroup) => (
          <Fragment key={storyGroup[0]?.id}>
            <div styleName="story-row">
              {storyGroup.map((story, index) => {
                const alternateStory = replaceWithAlternates(story)
                return (
                  <Fragment key={story?.id}>
                    <Link href={`/${story?.slug}`}>
                      <div styleName="card">
                        <p styleName="headline">{alternateStory?.headline}</p>
                        <figure styleName="image-container" style={{ "--aspect-ratio": 4 / 3 }}>
                          <ImageThumbnail story={story} />
                        </figure>
                      </div>
                    </Link>
                    {index !== storyGroup.length - 1 && <div styleName="divider"></div>}
                  </Fragment>
                );
              })}
            </div>
            <div styleName="row-divider"></div>
          </Fragment>
        ))
      )}
    </div>
  );
};
